/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfiguration {
    getFixupPrototypeFunction() { return GovernanceConfiguration.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfiguration>): GovernanceConfiguration {
        let obj = Object.assign(new GovernanceConfiguration(), model);
        GovernanceConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfiguration>): GovernanceConfiguration {
        if (!model) return null;
        return GovernanceConfiguration.newInstance(<GovernanceConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfiguration) {
        if (!obj) return;

        models.GovernanceConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfiguration): boolean {
        Object.setPrototypeOf(obj, GovernanceConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.settings) {
            for (let val of this.settings) {
                models.GovernanceConfigurationBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Governance Configuration settings
     */
    settings: Array<models.GovernanceConfigurationBase>;

}
